import axios from 'axios';
import { b64toBlob } from '~core';

export const getImageSize = (urlOrBase64) => {
  return new Promise((resolved) => {
    // Crea un blob dall'input
    const blobPromise = urlOrBase64.startsWith('http')
      ? axios({
          url: urlOrBase64,
          method: 'GET',
          responseType: 'blob',
        }).then((res) => res.data)
      : new Promise((resolve) => {
          if (urlOrBase64.startsWith('data:')) {
            const parts = urlOrBase64.split(';base64,');
            const contentType = parts[0].split(':')[1];
            const b64Data = parts[1];
            resolve(b64toBlob(b64Data, contentType));
          } else {
            resolve(b64toBlob(urlOrBase64, 'image/png'));
          }
        });

    blobPromise.then((imageBlob) => {
      const img = new Image();
      img.onload = () => {
        const dimensions = { w: img.width, h: img.height };
        const sizeInMB = imageBlob.size / (1024 * 1024);

        resolved({
          ...dimensions,
          //Arrotonda il peso in MB a 2 decimali
          s: Math.round(sizeInMB * 100) / 100,
        });
      };

      img.src = URL.createObjectURL(imageBlob);
    });
  });
};
